/**
 * TW PDP Waitlist — sync Klaviyo form visibility with show_waiting_list_form
 * (via data-tw-pdp-hide-purchase on the default PDP), and swap form ID per
 * variant (variant metafield → product metafield → app block formId).
 * Called from tw-variant-selector.js via window.TwPdpWaitlist.syncForVariantId.
 */
(function () {
  'use strict';

  function getRoot(sectionId) {
    return document.getElementById('MainProduct-' + sectionId);
  }

  function getProductData(root) {
    if (!root) return {};
    try {
      var el = document.getElementById(
        'TwPdpProductJSON-' + root.getAttribute('data-product-id')
      );
      return el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) {
      return {};
    }
  }

  function formIdFromClass(node) {
    if (!node || !node.className) return '';
    var match = String(node.className).match(/(?:^|\s)klaviyo-form-([A-Za-z0-9_-]+)(?:\s|$)/);
    return match ? match[1] : '';
  }

  function resolveFormId(productData, variantId) {
    var variants = (productData && productData.variants) || [];
    var variant = null;
    if (variantId != null && variantId !== '') {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          variant = variants[i];
          break;
        }
      }
    }
    var fromVariant =
      variant && variant.klaviyo_waitlist_form_id
        ? String(variant.klaviyo_waitlist_form_id).trim()
        : '';
    if (fromVariant) return fromVariant;
    var fromProduct =
      productData && productData.klaviyo_waitlist_form_id_product
        ? String(productData.klaviyo_waitlist_form_id_product).trim()
        : '';
    if (fromProduct) return fromProduct;
    return productData && productData.klaviyo_waitlist_form_id_fallback
      ? String(productData.klaviyo_waitlist_form_id_fallback).trim()
      : '';
  }

  function syncWaitlistVisibility(root) {
    if (!root || !root.hasAttribute('data-tw-pdp-has-klaviyo-waitlist')) return;

    var hidePurchase = root.getAttribute('data-tw-pdp-hide-purchase') === 'true';
    root.setAttribute('data-tw-variant-available', hidePurchase ? 'false' : 'true');

    // Visibility is CSS-driven via data-tw-pdp-hide-purchase (no HTML hidden —
    // that uses display:none and prevents Klaviyo from mounting).
    root.querySelectorAll('[data-tw-pdp-waitlist]').forEach(function (el) {
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', hidePurchase ? 'false' : 'true');
    });
  }

  function getKlaviyoMounts(root) {
    if (!root) return [];
    return root.querySelectorAll(
      '[data-tw-pdp-waitlist] [data-tw-klaviyo-form-mount], [data-tw-pdp-waitlist] .tw-pdp-waitlist__embed > [class*="klaviyo-form-"]'
    );
  }

  function ensureKlaviyoFormId(root, formId) {
    if (!root || !formId) return;
    var mounts = getKlaviyoMounts(root);
    mounts.forEach(function (node) {
      var currentId = formIdFromClass(node);
      var hasContent =
        node.childElementCount > 0 || (node.innerHTML || '').trim().length > 0;
      if (currentId === formId && hasContent) return;

      var parent = node.parentNode;
      if (!parent) return;
      var fresh = document.createElement('div');
      fresh.className = 'klaviyo-form-' + formId;
      fresh.setAttribute('data-tw-klaviyo-form-mount', '');
      parent.replaceChild(fresh, node);
    });
  }

  function remountKlaviyoEmbeds(root) {
    if (!root) return;
    var mounts = getKlaviyoMounts(root);
    mounts.forEach(function (node) {
      // Only remount empty placeholders; never destroy an already-rendered form.
      if (node.childElementCount > 0 || (node.innerHTML || '').trim().length > 0) {
        return;
      }
      var parent = node.parentNode;
      if (!parent) return;
      var clone = node.cloneNode(false);
      parent.replaceChild(clone, node);
    });
  }

  function tryKlaviyoReinit(root, variantId) {
    if (!root || root.getAttribute('data-tw-pdp-hide-purchase') !== 'true') return;
    var productData = getProductData(root);
    var formId = resolveFormId(productData, variantId);
    if (!formId) {
      var existing = getKlaviyoMounts(root)[0] || null;
      formId = formIdFromClass(existing);
    }
    ensureKlaviyoFormId(root, formId);
    remountKlaviyoEmbeds(root);
  }

  function syncForVariantId(sectionId, variantId) {
    var root = getRoot(sectionId);
    if (!root) return;
    syncWaitlistVisibility(root);
    tryKlaviyoReinit(root, variantId);
  }

  window.TwPdpWaitlist = {
    syncForVariantId: syncForVariantId
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info[data-tw-pdp-has-klaviyo-waitlist]').forEach(function (root) {
      syncWaitlistVisibility(root);
    });
  });
})();
